<template>
  <div>
      <h1 class="release">{{ release.name }}</h1>
      <div>
        <h2 class="release-time">
          {{ release.start_time | fullDate }} -
          {{ release.end_time | fullTime }}
        </h2>
        <h3>Time Slots</h3>
        <div
          v-for="timeslot in timeslots"
          :key="timeslot.id"
          class="time-slot"
          @click.self="toggleTimeslot(timeslot)"
          :style="
            timeslot.available_menu_items <= 0 && !timeslot.confirmationOpen
              ? disableTimeslot(timeslot)
              : ''
          "
        >
          <h4 class="clickthrough timeslot-title" v-show="!timeslot.visible">{{ timeslot.start_time | fullTime }} <span class="soft">{{ availableItemsCopy('item', timeslot.available_menu_items) }}</span></h4>
          <div v-show="timeslot.visible">
            <OrderForm
              :pickupLocation="release.pickup_location"
              :menu_items="release.menu_items"
              :add_ons="release.add_ons"
              :merch="release.merches"
              :timeslot="timeslot"
              :releaseName="release.name"
              :releaseType="'sandwich'"
              :minimumQuantity="release.minimum_quantity"
              :timeslotMessageStart="timeslot.start_time | fullTime"
              :timeslotMessageEnd="availableItemsCopy('item', timeslot.available_menu_items)"
              @order-submitted="orderSubmitted(timeslot, $event)"
              @decrement-quantity="decrementQuantity(timeslot, $event)"
            />
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import OrderForm from '@/components/OrderForm.vue'
import moment from 'moment-timezone'

export default {

    components: {
        OrderForm
    },
    props: {
        release: Object,
        releaseIndex: Number,
        timeslots: Array
    },
    filters: {
      fullTime: function(date) {
        return moment(date).format('h:mma')
      },
      fullDate: function(date) {
        return moment(date).format('dddd, MMMM Do YYYY h:mma')
      }
  },
  methods: {
    availableItemsCopy: function(itemType, quantity) {
      if (quantity > 0) {
        return (
          quantity +
          ' ' +
          this.pluralize(itemType, quantity) +
          ' ' +
          'available'
        )
      } else {
        return 'SOLD OUT!'
      }
    },
    decrementQuantity: function(timeslot, quantity) {
      timeslot.available_menu_items -= quantity
    },
    showDescriptionButtonPressed: function(release) {
      release.showDescription = !release.showDescription
    },
    disableTimeslot: function(timeslot) {
      return { 'pointer-events': 'none', opacity: 0.4 }
    },
    orderSubmitted: function(timeslot, quantity) {
      if (timeslot.available_menu_items == quantity) {
        timeslot.visible = !timeslot.visible
      }

      timeslot.available_menu_items -= quantity
    },
    toggleTimeslot: function(timeslot) {
      timeslot.confirmationOpen = false
      timeslot.visible = !timeslot.visible
    },

    pressedTimeslot: function() {
      confirm("Yes'm!")
    }
  }
}
</script>

<style>
  .timeslot-title {
    width: max-content;
    margin-left: auto;
    margin-right: auto;
  }
</style>